import React, { ReactElement, useEffect } from 'react';
import { useLocation, useParams } from 'react-router';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import routes from '../../../routing/routes';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import GlobalErrors from '../../../module/GlobalErrors';
import Layout from '../../Layout';
import PredkladatelUpdate from '../../../module/LegislativnyMaterial/PredkladatelUpdate';
import useLegislativnyMaterialDetail
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail/hooks/useLegislativnyMaterialDetail';
import { useUserContext } from '../../../context/UserContext';
import SecuredPage from '../../../module/SecuredPage';
import { canUpdatePredkladatel } from '../../../function/permissions';
import PracovnyKrokEnum from '../../../model/pracovnyKrok/PracovnyKrokEnum';
import SuccessMessages from '../../../module/SuccessMessages';

const PredkladatelUpdatePage = (): ReactElement => {
  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail(PracovnyKrokEnum.PREDKLADATEL_UPDATE_FUNCTION);
  const currentLocation = useLocation();
  const { pouzivatel } = useUserContext();
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();

  function isPredbeznaInformacia(): boolean {
    return type === 'PI';
  }

  useEffect(() => {
    if (!materialStatus.loading) {
      setTitle(getTitle());
    }
  }, [materialStatus.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: isPredbeznaInformacia() ? 'Predbežné informácie' : 'Legislatívne procesy',
          to: isPredbeznaInformacia() ? routes.procesy.predbeznaInformacia.list : routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          to: currentLocation.pathname,
          heading: 'Zmena predkladateľa',
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading}>
        <SecuredPage
          additionalCheck={canUpdatePredkladatel(pouzivatel, materialDetail)}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail?.aktualnyPredkladatel?.uuid
              && materialDetail?.aktualnaPredkladatelskaInstitucia?.uuid
              && (
              <>
                <PageHeadingWithBackButton
                  heading="Zmena predkladateľa"
                  headingCaption={`Legislatívny proces ${type}/${year}/${index}`}
                />
                <PredkladatelUpdate
                  materialDetail={materialDetail}
                />
              </>
              )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default PredkladatelUpdatePage;
